import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GridaService } from '../service/grida.service';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {

  snowflakes = new Array(50);

  isRecording = false;
  mediaRecorder;
  audioArray = [];
  image = null;
  sttRequest;

  questions: string = '';
  questioning: boolean = false;
  generatingAnswer: boolean = false;

  chatRequests = [];

  public talkCount = 0;

  constructor(
    private gridaService: GridaService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.gridaService.getGritalkCount().subscribe(res => {
      this.talkCount = res.count;
    });
  }

  public generateAnswerToText(event) {
    const questions = this.questions;

    if (this.questions !== '') {
      this.questions = '';
      this.generatingAnswer = true;

      this.gridaService.generateAnswerToText(questions).subscribe(res => {
        console.log(res);

        this.resultBinding(res);
      });
    }

  }

  public generateAnswerToVoice() {
    this.questioning = true;
    if (!this.isRecording) {
      this.startRecording();
    } else {
      this.timeout();
    }
  }

  public timeout() {
    setTimeout(() => {
      this.mediaRecorder.stop();
      setTimeout(() => {
        this.stopRecording();
      }, 100);
    }, 400);
  }

  public async startRecording() {
    this.isRecording = true;
    const mediaStream: MediaStream = await navigator.mediaDevices.getUserMedia({audio: true});
    this.mediaRecorder = new MediaRecorder(mediaStream);
    this.mediaRecorder.ondataavailable = (event) => {
      this.audioArray.push(event.data);
    };

    this.mediaRecorder.start();
  }

  public stopRecording() {
    const inputBlob = new Blob(this.audioArray, {type: 'audio/mpeg codecs=mp3'});
    this.questioning = false;
    this.generatingAnswer = true;

    this.gridaService.generateAnswerToVoice(inputBlob).subscribe(res => {
      this.resultBinding(res);
      this.addGritalkCount();
    }, error => {
      alert('실행 오류. 재실행 해주세요.');
      this.mediaRecorder = null;
      this.audioArray = [];
      this.isRecording = false;

      this.generatingAnswer = false;

      const view = document.getElementById('view');
      const viewHeight = view.scrollHeight;
    });
  }

  public resultBinding(res) {
    const value = JSON.parse(atob(res[0].result));
    console.log(value);

    this.sttRequest = value;

    const questions = {
      host: 'user',
      message: value.sttText
    };
    this.chatRequests.push(questions);

    const answer = {
      host: 'ai',
      message: value.answer
    }
    this.chatRequests.push(answer);

    // media 변수 초기화
    this.mediaRecorder = null;
    this.audioArray = [];
    this.isRecording = false;

    this.generatingAnswer = false;

    const view = document.getElementById('view');
    const viewHeight = view.scrollHeight;

    setTimeout(() => {
      view.scrollTo(0, viewHeight);
    }, 10);
  }

  addGritalkCount() {
    this.gridaService.addGritalkCount().subscribe(res => {
      console.log(res);
      this.talkCount = res.count;
    });
  }

}
